import { useCallback, useRef, useState } from "react";

const useRect = () => {
  const resizeObserver = useRef(null);
  const cleanup = useRef(null);
  const [ rect, setRect ] = useState({
    x: null,
    y: null,
    width: null,
    height: null,
    top: null,
    right: null,
    bottom: null,
    left: null
  });

  const onNode = useCallback(
    node => {
      cleanup.current && cleanup.current();

      if (!node) {
        return;
      }

      resizeObserver.current = new ResizeObserver(
        entries => {
          entries.forEach(entry => {
            const { contentRect: rect } = entry;

            setRect({
              x: rect.x,
              y: rect.y,
              width: rect.width,
              height: rect.height,
              top: rect.top,
              right: rect.right,
              bottom: rect.bottom,
              left: rect.left
            });
          });
        },
        { box: 'border-box' }
      );

      resizeObserver.current.observe(node);

      cleanup.current = () => {
        resizeObserver.current && resizeObserver.current.disconnect();
        resizeObserver.current = null;
      }
    },
    []
  );

  return [ rect, onNode ];
};

export default useRect;
